import noop from 'lodash/noop'

export interface InternalHref {
  kind: 'internal'
  href: string
}

export interface ExternalHref {
  kind: 'external'
  href: string
}

export type Href = InternalHref | ExternalHref

export type InternalHosts = string[]

export function getHrefValue(
  originalHref: string,
  internalHosts: InternalHosts,
): string {
  let hrefValue = originalHref.trim()
  hrefValue = normalizeProtocolRelativeURL(hrefValue)
  try {
    const hrefURL = new URL(hrefValue)
    if (internalHosts.includes(hrefURL.host)) {
      hrefValue = `${hrefURL.pathname}${hrefURL.search}${hrefURL.hash}`
    }
  } catch {
    noop()
  }
  return hrefValue
}

export function normalizeProtocolRelativeURL(
  protocolRelativeURL: string,
): string {
  return protocolRelativeURL.replace(/^\/\//, `https://`)
}

export function getInternalOrExternalHref(
  originalHref: string,
  internalHosts: InternalHosts,
): Href {
  const hrefValue = getHrefValue(originalHref, internalHosts)
  const checkIsInternalHref =
    hrefValue.startsWith('/') || hrefValue.startsWith('#')
  return {
    kind: checkIsInternalHref ? 'internal' : 'external',
    href: hrefValue,
  }
}

export function isInternalHref(hrefInfo: Href): hrefInfo is InternalHref {
  return hrefInfo.kind === 'internal'
}
